import { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import MiraLearnMoreModal from "./MiraLearnMoreModal";
import ErrorModal from "../Security/ErrorModal";

Modal.setAppElement('#root');

const MiraDataSync = ({
  isOpen,
  onClose,
  email,
  userInfo,
  deviceType,
  miraLoginURL,
  token,
  isHighmarkPortal,
  serviceDescription
}) => {
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleConsent = async (consentValue) => {
    setLoading(true);
    const params = {
      EmailID: email,
      AppUserId: userInfo.userData.AppUserId,
      DeviceType: deviceType,
      Consent: consentValue
    };
    try {
      const response = await axios.post(
        Endpoints.SaveMiraDataSyncConsent,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (consentValue === "Y" && response.data?.result === 1) {
        if (miraLoginURL.includes("https://")) {
          window.open(miraLoginURL, '_blank', 'noopener,noreferrer');
          onClose();
        }else{
          setShowErrorModal(true);
          setModalMessage(response.data?.resultText || "Details Saved Successfully");
          onClose();
        } 
      } else if (consentValue === "N" && response.data?.result === 1) {
        setShowLearnMoreModal(true);
        onClose();
      } else {
        onClose();
      }
    } catch (error) {
      onClose();
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  // Consent modal
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        className="tracker-modal-content-a"
        overlayClassName="tracker-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <h2 style={{ fontWeight: 700, fontSize: "1.5rem", marginBottom: "1rem", textAlign: "center" }}>
          Sync your Mira Data
        </h2>
        <p style={{ marginBottom: "2rem", textAlign: "center" }}>
          {`Are you using a Mira device to track your hormones? Syncing it with the ${isHighmarkPortal ? "Fertility and Family Building Portal" : "WINFamily App"} lets you see your hormone results alongside your full fertility tracker - and, with your consent, securely share them with your ${isHighmarkPortal ? "" : "WIN"} Nurse Care Advocate and provider for more personalized support`}.
        </p>
        <div className="mb-4 row align-items-center" style={{ justifyContent: "center" }}>
          <div className="col-12 mb-3">
            <button
              className="win-btn-primary model-popup-btn w-100"
              style={{ borderRadius: "24px", fontWeight: 600 }}
              onClick={() => handleConsent("Y")}
            >
              Yes, Sync Now
            </button>
          </div>
          <div className="col-12">
            <button
              className="win-btn-secondary model-popup-btn w-100"
              style={{ borderRadius: "24px", fontWeight: 600 }}
              onClick={() => handleConsent("N")}
            >
              Not Right Now
            </button>
          </div>
        </div>
      </Modal>
      <MiraLearnMoreModal
        isOpen={showLearnMoreModal}
        onClose={() => setShowLearnMoreModal(false)}
        isHighmarkPortal={isHighmarkPortal}
        serviceDescription={serviceDescription}
        email={email}
        contract={userInfo?.userData.ContractIdentified}
        memberId={userInfo?.userData.MemberID}
      />
      <ErrorModal
        show={showErrorModal}
        message={modalMessage}
        onClose={()=>{setShowErrorModal(false)}}
        closeButton={true}
      />
    </>
  );
};

export default MiraDataSync;